export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/a70fe28c30edbe909cade8425716fdee.svg";